export default [
  {
    name: 'roomlist-dash',
    path: '/roomlist-dash',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Gestão de Hospedagem',
      icon: 'dvr',
      label: 'Gestão de Hospedagem',
      roles: ['Admin']
    }
  }
]
